import React, { useState, useRef, useEffect } from 'react';
import CheckSolid from "../../images/check-solid.svg";

interface ChatFontSizeProps {
  size?: string;
  setSize?: (value: string) => void;
}

const fontSizeList = ["9", "10", "12", "14", "15", "18", "24", "36", "48", "72", "96", "144"];

const ChatFontSize: React.FC<ChatFontSizeProps> = ({
  size = '15px',
  setSize,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const handleSelect = (value: string) => {
    setSize?.(value);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="chat-option-wrap chat-font" ref={dropdownRef}>
      <label htmlFor="fontSize">Font Size</label>
      <div className="custom-dropdown" onClick={toggleDropdown}>
        <div className="selected-option">
          <p className='no-select'></p><span>{size.replace('px', '')}</span>
        </div>
        {isOpen && (
          <div className="dropdown-options">
            {fontSizeList.map((fontSize) => {
              const fontSizePx = fontSize + 'px';
              return (
                  <div
                    key={fontSize}
                    className={`dropdown-option ${size === fontSizePx ? 'selected' : ''}`}
                    onClick={() => handleSelect(fontSizePx)}
                  >
                  {size === fontSizePx ? (
                    <img src={CheckSolid} alt="check" style={{ width: 16, height: 16 }} />
                  ) : (<p className='no-select' />)}
                  {fontSize}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <input type="hidden" name="fontSize" value={size} />
    </div>
  );
};

export default ChatFontSize;
